module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_5_1_continue_3.5ac84f45.png";